//import 'jquery-hoverintent';
jQuery( $ => {
	const $mobileButton = $( 'button.mobile-nav-toggle, .close-mobile-nav' ),
		$acMenu = $( '.ac-nav-collapse' );

	$mobileButton.on( 'click', e => {
		e.stopPropagation();
		$acMenu.toggleClass( 'mobile-open' );
	} );

	// Toggles submenus
	$( '.toggle-sub-menu' ).on( 'click', function() {
		$( this ).siblings( '.sub-menu-container, .sub-menu' ).toggleClass( 'show-sub-menu' );
		$( this ).toggleClass( 'sub-menu-open' );
		$( this ).parent().toggleClass( 'menu-opened' );
	} );

	// Show or hide site overlay on megamenu hover
	const intentIn = function() {
		$( '.site-overlay' ).addClass( 'visible' );
		$( this ).addClass( 'open' );
	};

	const intentOut = function() {
		$( '.site-overlay' ).removeClass( 'visible' );
		$( this ).removeClass( 'open' );
	};
	// Use jQuery's hover() to simulate the same behavior
	$( '.megamenu' ).hover(
		intentIn, // Trigger when mouse enters
		intentOut // Trigger when mouse leaves
	);

	// Close menu when clicking the AC Language Picker toggle
	$( '.top-header-mobile .aclp-toggle' ).on( 'click', () => {
		$( '.mobile-nav-toggle' ).trigger( 'click' );
	} );
} );
